import React, { useRef, useState } from "react";
import { Button } from "../generic/Button";
import { Tile } from "../generic/Tile";
import { TileList } from "../generic/TileList";
import { FormWrapper } from "./FormWrapper";

export const ManageRecipeIngredients = ({
  onClose,
  ingredients,
  setIngredients,
  removeIngredient,
}) => {
  const ingredientRef = useRef(null);
  ingredientRef.current?.focus();

  const [newIngredient, setNewIngredient] = useState("");

  const ingredientAlreadyExists = ingredients.some(
    (ingredient) => ingredient === newIngredient
  );

  const handleAdd = () => {
    setIngredients([...ingredients, newIngredient]);
    setNewIngredient("");
    ingredientRef.current?.focus();
  };

  return (
    <FormWrapper>
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <h1>Zutaten hinzufügen</h1>

        <div style={{ display: "flex" }}>
          <input
            type="text"
            id="ingredient"
            ref={ingredientRef}
            value={newIngredient}
            style={{ fontSize: "1.5rem" }}
            onChange={(e) => setNewIngredient(e.target.value)}
            autoFocus
          />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <Button
            style={{ backgroundColor: "lightgreen" }}
            disabled={!newIngredient || ingredientAlreadyExists}
            onClick={handleAdd}
          >
            ➕ Zutat
          </Button>

          <Button onClick={onClose}>☑️ Fertig</Button>
        </div>

        <h2>Zutaten</h2>

        <TileList>
          {ingredients.map((ingredient) => (
            <Tile
              key={ingredient}
              onClick={() => {
                removeIngredient(ingredient);
              }}
            >
              {ingredient}
            </Tile>
          ))}
        </TileList>
      </div>
    </FormWrapper>
  );
};
